import React from 'react';

import ProjectsList from 'components/features/Projects/ProjectsList';

import { useAppDispatch } from 'utils/hooks';

function Projects() {
  return (
    <div className="cart_page">
      <div className="content">
        <ProjectsList />
      </div>
    </div>
  );
}

export default Projects;
